import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Convo } from './Convo';
import { UserView } from './UserView';

export interface ConvoUserRow {
  id: number;
  convo_id: number;
  user_id: string;
  latest_read_message_id: number;
  latest_ntfd_message_id: number;
}

export const ConvoUser: Entity<ConvoUserRow> = {
  id: 'ConvoUser',
  title: 'Conversation User State',
  service: 'main',
  rowLabel: (row: ConvoUserRow) => [row.convo_id, row.user_id].join(' / '),
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.convo_user',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition:
        "user_id = '{userId}' OR convo_id IN (SELECT id from public.convo WHERE institution_id = {adminInstitutionId})",
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    convo_id: {
      seq: 10,
      label: 'Convo',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: Convo,
    },
    user_id: {
      seq: 15,
      label: 'User',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: UserView,
    },
    latest_read_message_id: {
      seq: 20,
      label: 'Latest Read Message Id',
      type: FieldType.Integer,
    },
    // Watermark for the current unread stretch: once this catches up past the last read mark,
    // the cron should not send another unread email until the user reads again.
    latest_ntfd_message_id: {
      seq: 25,
      label: 'Latest Notified by Email Message Id',
      type: FieldType.Integer,
    },
  },
};
